import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { DataserviceService } from '../dataservice.service';
import { HttpErrorResponse } from '@angular/common/http';
import {   LocalStorageService, LocalStorage } from 'angular-web-storage';
import * as $ from 'jquery';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';




@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  model: any = {};
  isLoginError:String;
  model1:any ={};
  constructor(private dataservice : DataserviceService,private router:Router,private modalService: NgbModal) { }

  onSubmit() {
    this.isLoginError = "";
    $('div#err.red-text.center.error-message .error-message1').fadeIn(1000);
    $('div#err.red-text.center.error-message .error-message1').fadeOut(9000);
  console.log(this.isLoginError);
  
    

    this.dataservice.adminLogin(this.model).subscribe(
   data=>{
        
        console.log(data);
        localStorage.setItem('userToken',data.session_id);
            this.router.navigate(['/dashboard']);

      },
      (err : HttpErrorResponse)=>{
        console.log(err.error.error_description);

        this.isLoginError = err.error.error_description;
       
      }
      );
        

  }




  openforgetPassPopup(id){
    this.modalService.open(id);

  }


  forgotPass(){
    console.log(this.model1.forgetPassEmail);
    this.dataservice.forgotPass1(this.model1.forgetPassEmail).subscribe(
      data=>{
        console.log(data);
        this.model1.forgetPassEmail = "";
        this.modalService.dismissAll();
        swal("Reset link sent on your email");

      },
      (err : HttpErrorResponse)=>{
        console.log(err.error.error_description);

       swal(err.error.error_description);
       
      }
    )
    
  }


  ngOnInit() {
    

    
    
  }

}
